<template>
  <div>
    <Loading :isActive="loading" />
    <CTabs variant="tabs" class="nav-tabs-boxed">

      <CTab
        title="Logos"
      >
        <Logotipos
          :logos="logos"
          :logoUrl="images.logo"
          :faviconUrl="images.favicon"
          :upload="handleUpload"
          :deleteLogo="handleDelete"
          :hash="hash"
          :loading="loading"
        />
      </CTab>
      <CTab
        title="Imagens de Fundo/Login"
      >
        <Backgrounds
          :baseUrl="images.background"
          :sistemas="sistemasPermitidos"
          :hash="makeHash"
          :upload="handleUpload"
          :hashs="hashs"
        />
      </CTab>
    </CTabs>
  </div>
</template>
<script>
import {get, upload, del} from "@/helpers/apiRequest";
import config from "@/config";
import Logotipos from "./Logotipos/Logotipos.vue";
import Backgrounds from "./Backgrounds/Backgrounds.vue";
import Toast from "vue-toastification";
import Vue from "vue";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";
import _reduce from "lodash/reduce";
import {confirmDelete} from "@/helpers/crud";
Vue.use(Toast, {});

export default {
  name: "configuracoes",
  components: {
    Backgrounds,
    Logotipos,
    Toast,
  },
  props: [
    "sistemas",
  ],
  computed: {
    sistemasPermitidos() {
      return _reduce(this.sistemas, (acc, sistema) => {
        if (this.sistemasDefault.indexOf(sistema.chave) >= 0) {
          acc.push(sistema.chave);
        }
        return acc;
      }, []);
    },
  },
  data() {
    return {
      loading: false,
      sistemasDefault: [
        'B2B',
        'CALLCENTER',
        'ADMIN',
        'SAC'
      ],
      hashs: {
        B2B: null,
        CALLCENTER: null,
        ADMIN: null,
        SAC: null,
      },
      hash: this.makeHash(),
      logos: [],
      images: {
        logo: config.api + "/images/logo",
        logo_secundaria: config.api + "/images/logo-secundaria",
        favicon: config.api + "/images/favicon/icon-72x72",
        background: config.api + "/images/background/",
      },
      uploadedImages: {
        logo: config.api + "/images/logo",
        logo_secundaria: config.api + "/images/logo-secundaria",
        favicon: config.api + "/images/favicon/icon-72x72",
        background: config.api + "/images/background/",
      },
      urls: {
        logo: config.api + "/admin/logo",
        logo_secundaria: config.api + "/admin/logo-secundaria",
        favicon: config.api + "/admin/favicon",
        background: config.api + "/admin/background",
      },
      paths: {
        logo: "/admin/logo",
        logo_secundaria: "/admin/logo-secundaria",
        favicon: "/admin/favicon",
        background: "/admin/background",
      },
    };
  },
  methods: {
    makeHash() {
      let text = "";
      let possible =
          "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

      for (let i = 0; i < 5; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));

      return text;
    },
    loadLogos() {
      this.loading = true;
      get('/admin/logos')
        .then((json) => this.logos = json)
        .then(() => (this.loading = false))
        .catch(() => (this.loading = false));

      this.hash = this.makeHash();
    },
    handleUpload(type, extraInputs) {
      event.preventDefault();

      const self = this;

      this.loading = true;

      return upload(
        this.urls[type],
        "image",
        event.target.files[0],
        extraInputs
      )
        .then((response) => {
          this.loading = false;
          this.loadLogos();
        })
        .catch((error) => {
          this.loading = false;
          alert(error.message);
        });
    },
    handleDelete(type, extraInputs) {
      const self = this;

      return confirmDelete(
          this.paths[type],
          () => {
            this.loadLogos();
          },
          extraInputs
      )
    },
  },
  beforeMount() {
    this.loadLogos();
  },
};
</script>
